import axios from "axios";
import $ from "jquery";
import moment from "moment";
import { useContext, useEffect, useRef, useState } from "react";
import { BiCreditCard, BiInfoCircle } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import CommonAsyncSelect from "../../components/CommonAsyncSelect";
import Swal from "sweetalert2";
import ApiSuccessModal from "../../components/ApiSuccessModal/ApiSuccessModal";
import Breadcrumb from "../../components/Breadcrumb";
import Header from "../../components/partials/Header";
import Sidebar from "../../components/partials/Sidebar";
import PayDtlCard from "../../components/PayDtlCard";
import TruncatedTextWithTooltip from "../../components/TruncatedTextWithTooltip";
import config from "../../config";
import addIcon from "../../images/icons/add.png";
import deleteIcon from "../../images/icons/delete.png";
import { v4 as uuidv4 } from "uuid";
import {
  inputAlphanumeric,
  inputfourDigitDeciaml,
  inputOnlyNumber,
  millionComma,
  playBarcodeSound,
  removeMillionComma,
  userBackDate,
} from "../../utils";
import salesSchema from "../../validations/salesSchema";
import { uomConversion, uomConversionUnit } from "../Sale/util";
import "./style.css";
import { ConfigContext } from "../../App";
import Tippy from "@tippyjs/react";
import { Modal } from "react-bootstrap";
import ItemViews from "../Master/Item/view";
import CustomCurrencyInput from "../../components/CustomCurrencyInput";

function SaleAdd(props) {
  const navigate = useNavigate();
  const [godown, setGodown] = useState([]);
  const [defaultGodown, setDefaultGodown] = useState("");
  const [defaultCustomer, setDefaultCustomer] = useState("");
  const [showItemModal, setShowItemModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const handleItemView = (data) => {
    setSelectedItemId(data);
    setShowItemModal(true);
  };
  const handleItemModalClose = () => {
    setShowItemModal(false);
    setSelectedItemId(null);
  };

  const itemLevelNarration = useContext(ConfigContext)?.itemLevelNarration;
  const displayQty = useContext(ConfigContext)?.displayQty;
  console.log("displayQtydisplayQty", displayQty);

  const multiVoucher = useContext(ConfigContext)?.multiVoucher;

  useEffect(
    function () {
      setGodown(() => props.godown);
    },
    [props],
  );

  const itemDtl = {
    item_id: "",
    item_name: "",
    requested_qty: "",
    rate: "",
    amount: "",
    disc: "",
    disc_amt: "",
    godown_id: defaultGodown,
    avail_qty: "",
    billedQty: "",
    alt_conv: "",
    base_uom: "",
    alt_uom: "",
    uom: "",
    alt_qty: "",
    alt_price: "",
    alt_rate: "",
    base_rate: "",
    item_min_price: "",
    alt_min_price: "",
    item_max_price: "",
    alt_max_price: "",
    narration: "",
  };

  const payDtl = [
    { mode: "Cash UGX", conv: 1, conv_amt: "", amt: "" },
    { mode: "USD", conv: 1, conv_amt: "", amt: "" },
    { mode: "Momo Pay", conv: 1, conv_amt: "", amt: "" },
    { mode: "Airtel Money", conv: 1, conv_amt: "", amt: "" },
  ];

  const getInitialState = () => ({
    branch_id: "",
    inv_no: "",
    cust_id: "",
    challan_date: moment().format("YYYY-MM-DD"),
    payment_mode_id: 1,
    item_dtl: [itemDtl],
    narration: "",
    vehicle_no: "",
    is_zero_value: "0",
    pay_dtl: payDtl,
    voucher_id: "",
    uuid: uuidv4(),
  });

  const [formInputs, setFormInputs] = useState(getInitialState);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedProduct, setSelectedProduct] = useState([]);
  console.log("selectedCustomer", formInputs);

  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [productGodown, setproductGodown] = useState("");

  const [barcode, setBarcode] = useState("");
  const [barcodeLoading, setBarcodeLoading] = useState(false);
  const [highlightedRow, setHighlightedRow] = useState(null);
  const barcodeRef = useRef();

  const defaultGodownRef = useRef("");
  const godownRef = useRef([]);

  useEffect(() => {
    defaultGodownRef.current = defaultGodown;
    godownRef.current = godown;
  }, [defaultGodown, godown]);
  // resp modal
  const [showSccess, setShowSccess] = useState(false);
  const [resData, setResData] = useState();

  const handleSccessClose = () => setShowSccess(false);
  const handleSccessShow = () => setShowSccess(true);
  const discRef = useRef(0);
  const totalRef = useRef(0);

  const [totalValue, setTotalValue] = useState("");
  useEffect(() => {
    const interval = setInterval(() => {
      if (totalRef.current) {
        setTotalValue(totalRef.current.value);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);
  const focus = useRef([{}]);

  // Get and Set Default Customer
  useEffect(() => {
    let branch_id =
      JSON.parse(localStorage.getItem("inventory")).userData.branch_data[0]
        .branch_id || null;
    $.post(
      `${config.apiUrl}/customer/listCustomer`,
      JSON.stringify({ is_active: 1, is_default: branch_id }),
      (res) => {
        if (res?.data?.list?.[0]) {
          setDefaultCustomer(res.data.list[0]);
          setSelectedCustomer(res.data.list[0]);
          setFormInputs((prevState) => ({
            ...prevState,
            cust_id: res.data.list[0]?.cust_id,
          }));
        }
      },
    );
  }, []);

  const [user, setUser] = useState("");
  const [itemList, setItemList] = useState([]);
  const [itemLoading, setItemLoading] = useState(false);

  async function getItem() {
    setItemLoading(true);
    let branch_id = user;
    if (!branch_id && localStorage.getItem("inventory")) {
      branch_id = JSON.parse(localStorage.getItem("inventory"))?.userData?.branch_data?.[0]?.branch_id;
    }

    try {
      await $.post(
        `${config.apiUrl}/item/listItem`,
        JSON.stringify({
          paginate: 0,
          is_active: 1,
          branch_id: branch_id || "",
          is_preload: 1,
        }),
        function (res) {
          setItemList(res?.data?.list || []);
        }
      );
    } catch (err) {
      console.error("Item API Error", err);
      setItemList([]);
    } finally {
      setItemLoading(false);
    }
  }

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(
        JSON.parse(localStorage.getItem("inventory")).userData.branch_data[0]
          .branch_id,
      );
    }
  }, []);

  useEffect(() => {
    if (user) {
      getItem();
    }
  }, [user]);

  function calculateTotal() {
    discRef.current.value = 0;
    totalRef.current.value = 0;
    formInputs.item_dtl.forEach((item) => {
      totalRef.current.value = removeMillionComma(totalRef.current.value);
      let disc = isNaN(parseFloat(discRef.current.value))
        ? 0
        : parseFloat(discRef.current.value);
      let disc_amt = isNaN(parseFloat(item.disc_amt))
        ? 0
        : parseFloat(item.disc_amt);
      discRef.current.value = parseFloat(disc + disc_amt).toFixed(2);

      let total = isNaN(parseFloat(totalRef.current.value))
        ? 0
        : parseFloat(totalRef.current.value);
      let total_amt = isNaN(parseFloat(item.amount))
        ? 0
        : parseFloat(item.amount);
      let amt = parseFloat(total + total_amt).toFixed(2);
      totalRef.current.value = millionComma(amt);
    });
    setSelectedProduct((prevState) => {
      return formInputs.item_dtl;
    });
  }

  function handleInputs(e) {
    setFormInputs((prevState) => {
      let newState = {
        ...prevState,
        [e.target.name]: e.target.value,
      };
      return newState;
    });
  }

  function handleTableInputs(e, rowIndex) {
    let idx =
      rowIndex !== undefined
        ? rowIndex
        : window.event?.target?.closest("tr")?.getAttribute("data-id") ||
        window.event?.srcElement?.closest("tr")?.getAttribute("data-id");

    setHighlightedRow(Number(idx));

    let product = formInputs.item_dtl[idx];

    if (e.target.name == "item_id") {
      let oldProduct = product;
      product = e.target.value;
      delete product.godown_id;
      product.item_min_price = product?.item_min_price || 0;
      product.item_max_price = product?.item_price || 0;
      product.alt_min_price = product?.alt_min_price || 0;
      product.alt_max_price = product?.alt_price || 0;
    }
    let rate =
      e.target.name == "rate"
        ? e.target.value
        : product?.rate || product?.item_price || 0;
    let narration =
      e.target.name == "narration" ? e.target.value : product?.narration || "";
    let item_max_price =
      e.target.name == "item_max_price"
        ? e.target.value
        : product?.item_max_price || product?.item_price || 0;

    let alt_max_price =
      e.target.name == "alt_max_price"
        ? e.target.value
        : product?.alt_max_price || product?.alt_price || 0;

    let item_min_price =
      e.target.name == "item_min_price"
        ? e.target.value
        : product?.item_min_price || 0;
    let alt_min_price =
      e.target.name == "alt_min_price"
        ? e.target.value
        : product?.alt_min_price || 0;
    let base_rate = product?.base_rate || rate;
    let alt_price =
      e.target.name == "alt_price"
        ? e.target.value
        : product?.alt_price || product?.alt_price || 0;
    let alt_rate = product?.alt_rate || product?.alt_price || 0;

    let qty =
      e.target.name == "requested_qty"
        ? e.target.value
        : product.requested_qty || 1;

    // let godownList = godown.map((x) => x.godown_id);

    // let godown_id =
    //   e.target.name == "godown_id"
    //     ? e.target.value
    //     : godownList.includes(Number(product?.godown_id))
    //     ? product?.godown_id
    //     : godownList.includes(Number(product?.item_godown))
    //     ? product?.item_godown
    //     : defaultGodown;
    let currentGodownList = godownRef.current.map((x) => Number(x.godown_id));

    console.log("currentGodownList",currentGodownList)

    let godown_id = defaultGodownRef.current;

    if (e.target.name === "godown_id" || product?.item_id) {
      const currentProductId = product?.item_id || e?.item_id;
      const usedGodowns = formInputs.item_dtl
        .filter(
          (item, index) =>
            index !== parseInt(idx) &&
            item.item_id === currentProductId &&
            item.godown_id,
        )
        .map((item) => Number(item.godown_id));

      const availableGodowns = currentGodownList.filter(
        (gid) => !usedGodowns.includes(gid),
      );

      let matchedGodown = null;
      let existingGodown = Number(product?.godown_id || product?.item_godown);

      if (existingGodown && availableGodowns.includes(existingGodown)) {
        matchedGodown = existingGodown;
      } else if (product?.item_godown_data?.length > 0) {
        let found = product.item_godown_data.find((g) =>
          availableGodowns.includes(Number(g.godown_id)),
        );
        if (found) {
          matchedGodown = Number(found.godown_id);
        }
      }

      godown_id =
        e.target.name === "godown_id"
          ? e.target.value
          : matchedGodown
            ? String(matchedGodown)
            : availableGodowns[0] || defaultGodownRef.current;
    }

    let alt_conv = product?.alt_conv;
    let base_uom = product?.base_uom || product?.item_unit;
    let alt_uom = product?.alt_uom || product?.alt_unit;
    let base_conv = parseFloat(product?.base_conv || 1);
    let uom =
      e.target.name == "uom"
        ? e.target.value
        : product.uom || product.base_uom || product?.item_unit;

    let alt_qty = product?.alt_conv || 1;

    alt_qty = parseFloat(alt_conv) / parseFloat(base_conv);

    if (e.target.name == "uom") {
      // qty = product.alt_qty;
      alt_price = alt_rate;
      rate = base_rate;
    }

    if (uom == alt_uom) {
      alt_qty =
        product.alt_conv == 1 ? parseFloat(base_conv) : base_conv / alt_conv;
      // rate = alt_price * alt_conv;
      rate = (alt_price * alt_conv).toFixed(4);
    } else if (uom === base_uom) {
      // alt_price = rate / alt_conv;
      alt_price = (rate / alt_conv).toFixed(4);
    }

    const grossAmt =
      uom === base_uom
        ? parseFloat(rate * qty).toFixed(4)
        : parseFloat(alt_price * qty).toFixed(4);
    // : parseFloat(
    //   rate * (parseFloat(alt_qty) * parseFloat(qty)).toFixed(2)
    // ).toFixed(4);

    let disc = e.target.name == "disc" ? e.target.value : product.disc || 0;
    let discAmt = parseFloat((grossAmt * parseFloat(disc)) / 100).toFixed(4);
    getAvailableItem(product.item_id, godown_id, idx);

    let prodDtl = {
      item_id: product.item_id,
      item_name: product.item_name,
      narration: narration,
      requested_qty: qty,
      rate: isNaN(rate) ? 0 : rate,
      disc: disc,
      godown_id: godown_id,
      avail_qty: currentGodownList.includes(Number(product?.item_godown))
        ? product?.godownQty
        : product?.avail_qty || 0,
      billedQty: currentGodownList.includes(Number(product?.item_godown))
        ? product?.billedQty
        : product?.billedQty || product?.billedQty || 0,

      // billedQty: product?.billedQty || 0,
      amount: isNaN(grossAmt) ? 0 : Number(grossAmt),
      disc_amt: isNaN(discAmt) ? 0 : discAmt,
      alt_conv: alt_conv,
      base_uom: base_uom,
      alt_uom: alt_uom,
      uom: uom,
      alt_price: alt_price,
      alt_rate: alt_rate,
      base_rate: base_rate,
      // alt_qty: alt_qty,
      alt_qty: (parseFloat(alt_qty) * parseFloat(qty)).toFixed(4),
      item_min_price: item_min_price,
      alt_min_price: alt_min_price,
      item_max_price: item_max_price,
      alt_max_price: alt_max_price,
    };
    let existProdDtl = formInputs.item_dtl;
    existProdDtl[idx] = prodDtl;
    setFormInputs((prevState) => {
      let newState = {
        ...prevState,
        item_dtl: existProdDtl,
      };
      return newState;
    });
  }

  const handleBarcodeInput = (item) => {
    setFormInputs((prev) => {
      let existItemIndex = prev.item_dtl.findIndex(
        (row) => row.item_id == item.item_id,
      );

      if (existItemIndex !== -1) {
        // Increment quantity in existing row
        setHighlightedRow(existItemIndex);
        setTimeout(() => {
          let currentQty = parseFloat(
            prev.item_dtl[existItemIndex].requested_qty || 0,
          );
          handleTableInputs(
            {
              target: { name: "requested_qty", value: currentQty + 1 },
            },
            existItemIndex,
          );
        }, 1);
        return prev;
      } else {
        // Add new item
        let emptyRowIndex = prev.item_dtl.findIndex((row) => !row.item_id);
        let newIdx =
          emptyRowIndex !== -1 ? emptyRowIndex : prev.item_dtl.length;

        setHighlightedRow(newIdx);

        setSelectedProduct((prevState) => {
          let newState = [...prevState];
          newState[newIdx] = item;
          return newState;
        });

        if (emptyRowIndex !== -1) {
          setTimeout(() => {
            handleTableInputs(
              {
                target: { name: "item_id", value: item },
              },
              emptyRowIndex,
            );
          }, 1);
          return prev;
        } else {
          // Add a new row
          let updatedItemDtl = [...prev.item_dtl, itemDtl];
          setTimeout(() => {
            handleTableInputs(
              {
                target: { name: "item_id", value: item },
              },
              newIdx,
            );
          }, 1);
          return { ...prev, item_dtl: updatedItemDtl };
        }
      }
    });
  };

  const scanBarcode = (e) => {
    if (e) e.preventDefault();
    if (isSubmit) return;
    if (!barcode || barcode.trim().length < 2) return;

    setBarcodeLoading(true);
    $.post(
      `${config.apiUrl}/item/listItem`,
      JSON.stringify({
        paginate: 0,
        is_active: 1,
        barcode: barcode.trim(),
      }),
      (res) => {
        setBarcodeLoading(false);
        let list = res?.data?.list || [];
        if (list.length > 0) {
          playBarcodeSound(true);
          handleBarcodeInput(list[0]);
          setBarcode("");
          setTimeout(() => {
            if (barcodeRef.current) barcodeRef.current.focus();
          }, 200);
        } else {
          playBarcodeSound(false);
          Swal.fire({
            html: "Product not available of this barcode",
            icon: "error",
            confirmButtonText: "Close",
            allowEnterKey: true,
            allowEscapeKey: true,
            didOpen: () => {
              Swal.getConfirmButton().focus();
            },
          }).then(() => {
            setBarcode("");
            setTimeout(() => {
              if (barcodeRef.current) barcodeRef.current.focus();
            }, 200);
          });
        }
      },
    );
  };

  const validatePriceRange = (e, itemData) => {
    const { name, value } = e.target;
    const numericValue = parseFloat(value) || 0;

    // Get the current row index
    const idx = e.target.closest("tr").getAttribute("data-id");
    const currentItem = formInputs.item_dtl[idx];

    let minPrice = 0;
    let maxPrice = Infinity;
    let shouldUpdate = false;
    let newValue = value;

    if (name === "rate") {
      minPrice = parseFloat(currentItem.item_min_price) || 0;
      maxPrice = parseFloat(currentItem.item_max_price) || Infinity;
    } else if (name === "alt_price") {
      minPrice = parseFloat(currentItem.alt_min_price) || 0;
      maxPrice = parseFloat(currentItem.alt_max_price) || Infinity;
    }

    if (minPrice > 0 || maxPrice < Infinity) {
      if (numericValue < minPrice && minPrice > 0) {
        newValue = minPrice.toString();
        shouldUpdate = true;
      } else if (numericValue > maxPrice && maxPrice < Infinity) {
        newValue = maxPrice.toString();
        shouldUpdate = true;
      }

      if (shouldUpdate) {
        e.target.value = newValue;

        handleTableInputs({
          target: {
            name: name,
            value: newValue,
          },
        });
      }
    }
  };

  const validatePriceRangeOnBlur = (e, itemData) => {
    const { name, value } = e.target;
    const numericValue = parseFloat(value) || 0;

    const idx = e.target.closest("tr").getAttribute("data-id");
    const currentItem = formInputs.item_dtl[idx];

    let minPrice = 0;
    let maxPrice = Infinity;

    if (name === "rate") {
      minPrice = parseFloat(currentItem.item_min_price) || 0;
      maxPrice = parseFloat(currentItem.item_max_price) || Infinity;
    } else if (name === "alt_price") {
      minPrice = parseFloat(currentItem.alt_min_price) || 0;
      maxPrice = parseFloat(currentItem.alt_max_price) || Infinity;
    }
    if (minPrice <= 0) {
      return; // Skip validation entirely
    }
    // Show warning message and adjust value if out of range
    if (
      minPrice > 0 &&
      numericValue < minPrice &&
      formInputs?.is_zero_value != 1
    ) {
      Swal.fire({
        title: "Price Below Minimum",
        text: `Minimum price is ${minPrice}. Setting to minimum value.`,
        icon: "warning",
        timer: 4000,
      });
      e.target.value = minPrice.toString();
      handleTableInputs(e);
    }
    //  else if (
    //   maxPrice < Infinity &&
    //   numericValue > maxPrice &&
    //   formInputs?.is_zero_value != 1
    // ) {
    //   Swal.fire({
    //     title: "Price Above Maximum",
    //     text: `Maximum price is ${maxPrice}. Setting to maximum value.`,
    //     icon: "warning",
    //     timer: 4000,
    //   });
    //   e.target.value = maxPrice.toString();
    //   handleTableInputs(e);
    // }
  };
  const getAvlQty = (e, v, i) => {
    if (Number(v.item_godown)) {
      return v?.godownQty;
    } else {
      getAvailableItem(
        e.item_id,
        v?.godown_id ? v?.godown_id : defaultGodown,
        i,
        e,
      );
    }
  };

  function handleItemCount(v, i) {
    if (v == "+") {
      if (formInputs.item_dtl[formInputs.item_dtl.length - 1].item_id == "") {
        Swal.fire({ html: "Please fill proper data." });
      } else {
        let existProdDtl = formInputs.item_dtl;
        existProdDtl[formInputs.item_dtl.length] = itemDtl;
        setFormInputs({ ...formInputs, item_dtl: existProdDtl });
      }
    } else if (v == "-") {
      if (formInputs.item_dtl.length == 1) {
        Swal.fire({ html: "Can't delete last row." });
      } else {
        let existProdDtl = formInputs.item_dtl.filter((v, idx) => {
          return idx != i;
        });
        setFormInputs({ ...formInputs, item_dtl: existProdDtl });
      }
    }
  }

  async function getAvailableItem(item_id, godown_id, idx, data) {
    if (item_id && godown_id) {
      await $.post(
        `${config.apiUrl}/godownStock/listGodownStock`,
        JSON.stringify({ item_id, godown_id }),
      ).done(function (res) {
        let avail_qty = 0;
        let billedQty = 0;

        if (res?.data?.list?.length)
          avail_qty = res.data.list[0]?.avail_qty || 0;
        billedQty = res.data.list[0]?.billed_qty || 0;
        let existProdDtl = formInputs.item_dtl;
        existProdDtl[idx] = {
          ...existProdDtl[idx],
          avail_qty: avail_qty,
          billedQty: billedQty,
        };
        setFormInputs((prevState) => {
          let newState = {
            ...prevState,
            item_dtl: existProdDtl,
          };
          return newState;
        });
      });
    }
  }

  console.log("sjdshdjshdjsd", formInputs?.item_dtl);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isZeroValueYes =
      formInputs.is_zero_value === 1 || formInputs.is_zero_value === "1";

    if (isZeroValueYes) {
      const allRatesNonZero = formInputs.item_dtl.every((item) => {
        const effectivePrice =
          item?.uom === item?.alt_uom ? item?.alt_price : item?.rate;
        const priceValue = parseFloat(effectivePrice);
        return priceValue > 0;
      });
      if (allRatesNonZero) {
        const result = await Swal.fire({
          title: "Zero Value Confirmation",
          html: "Your <b>Zero Value</b> is set to <b>Yes</b> but <b>none</b> of your products have zero rate.<br><br>Do you want to create the Challan?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes, Create Challan",
          cancelButtonText: "No",
          allowOutsideClick: false,
        });

        if (!result.isConfirmed) {
          return;
        }
      }
    }

    let grossamtval = parseFloat(totalRef.current.value.replace(/,/g, ""));
    if (grossamtval == 0) {
      if (formInputs.narration == "") {
        Swal.fire({ html: "Narration is Required" });
        return;
      }
    }

    let remainingAmount = grossamtval || 0;
    formInputs?.pay_dtl?.forEach((pay) => {
      if (pay.mode !== "Cash UGX") {
        remainingAmount -= parseFloat(pay.amt || 0);
      }
    });

    // const updatedPayments = formInputs?.pay_dtl?.map((pay) => {
    //     if (pay.mode === "Cash UGX") {
    //         let amount = parseFloat(remainingAmount) < 0 ? grossamtval : parseFloat(remainingAmount)
    //         return { ...pay, amt: amount || 0, conv_amt: amount || 0 };
    //     } else {
    //         return parseFloat(remainingAmount) < 0 ? { ...pay, amt: '', conv_amt: '' } : pay
    //     }
    // });
    const updatedPayments = formInputs?.pay_dtl?.map((pay) => {
      if (pay.mode === "Cash UGX") {
        let amount = parseFloat(remainingAmount);
        return { ...pay, amt: amount || 0, conv_amt: amount || 0 };
      } else {
        return pay;
      }
    });
    setFormInputs((prevState) => ({
      ...prevState,
      pay_dtl: updatedPayments,
    }));

    if (formInputs.item_dtl.length > 1) {
      formInputs.item_dtl = formInputs.item_dtl.filter((p) => p.item_id != "");
    }
    let isInvalid = await salesSchema.validateAdd(formInputs);
    if (isInvalid?.errors) {
      Swal.fire("", isInvalid.errors[0]);
      return;
    }
    formInputs.branch_id = JSON.parse(
      localStorage.getItem("inventory"),
    )?.userData?.branch_data?.[0]?.branch_id;
    formInputs.total_amount = removeMillionComma(totalRef.current.value);
    formInputs.discount_amount = discRef.current.value;
    setIsSubmit(true);

    let prod = [...formInputs.item_dtl];
    for (let i = 0; i < prod.length; i++) {
      let element = {};
      element = prod[i];
      if (element.uom == element.alt_uom) {
        let newProdDtl = {
          ...element,
          requested_qty: element.alt_qty,
          alt_qty: element.requested_qty,
        };
        prod[i] = newProdDtl;
      }
    }

    let newFormData = {
      ...formInputs,
      item_dtl: prod,
      pay_dtl: updatedPayments,
    };

    try {
      let { data } = await axios.post(
        `${config.apiUrl}/challan/createChallan`,
        JSON.parse(JSON.stringify(newFormData).replace(/"\s+|\s+"/g, '"')),
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("inventory"))?.token,
          },
        },
      );
      await handleSccessShow();
      setResData(data);
      discRef.current.value = 0;
      totalRef.current.value = 0;
      setSelectedCustomer(() => defaultCustomer);
      setSelectedProduct(() => []);
      setDefaultGodown(() => "");
      setFormInputs(() => {
        return {
          ...getInitialState(),
          item_dtl: [{ ...itemDtl, godown_id: "" }],
          cust_id: defaultCustomer?.cust_id,
        };
      });
      setIsSubmit(false);
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.data?.message,
        confirmButtonText: "OK",
        allowEnterKey: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        focusConfirm: true,
      });
      setIsSubmit(false);
    }
  };

  useEffect(function () {
    focus.current[0].cust_id.focus();
  }, []);

  useEffect(
    function () {
      calculateTotal();
    },
    [formInputs],
  );

  const [showPayDtl, setShowPayDtl] = useState(false);
  const handlePayDtl = () => {
    setShowPayDtl((prevState) => !prevState);
  };
  function getPaymentMode() {
    const paymentModes = formInputs.pay_dtl.filter(
      (pay) => pay.amt !== "" && pay.amt !== undefined && pay.amt > 0,
    );

    if (paymentModes.length === 0) {
      return "Cash UGX";
    } else if (paymentModes.length === 1) {
      return paymentModes[0].mode;
    } else {
      return "Multiple";
    }
  }

  const [voucherList, setVoucherList] = useState([]);
  useEffect(() => {
    if (localStorage.getItem("inventory")) {
      const inv = JSON.parse(localStorage.getItem("inventory"));
      const userBranchId = inv?.userData?.branch_data?.[0]?.branch_id || "";
      $.post(
        `${config.apiUrl}/voucher/listVoucher`,
        JSON.stringify({
          paginate: 0,
          is_active: 1,
          module_name: "challan",
        }),
        function (res) {
          setVoucherList(res?.data?.list || []);
        },
      );
    }
  }, [isSubmit]);

  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2 position-relative pb-8">
          <Header />
          <Breadcrumb path={["Challan", "Add Challan"]} />

          <main className="bg-white rounded-2" id="saleAdd">
            <div className="container-fluid p-2 position-relative">
              <Link
                to="/challan"
                className="position-absolute text-decoration-none small"
                style={{ top: "-1.5rem", right: "0" }}
              >
                Go Back to List
              </Link>
              <form
                className="row gx-4 gy-2"
                autoComplete="off"
                onSubmit={handleSubmit}
              >
                <div className="row gx-3 mb-2 p-2">
                  <div className="col-md-3">
                    <label htmlFor="cust_id">
                      Customer Name
                      <span className="text-danger">*</span>
                    </label>
                    <CommonAsyncSelect
                      ref={(el) => (focus.current[0].cust_id = el)}
                      noOptionsMessage={() => null}
                      placeholder="Enter atleast 3 character"
                      getOptionLabel={(o) => o.customer_name}
                      getOptionValue={(o) => o.cust_id}
                      loadOptions={async (inputValue, callback) => {
                        if (inputValue.toString().length > 2) {
                          await $.post(
                            `${config.apiUrl}/customer/listCustomer`,
                            JSON.stringify({
                              paginate: 0,
                              is_active: 1,
                              customer_name: inputValue,
                            }),
                            function (res) {
                              callback(res?.data?.list || []);
                            },
                          );
                        } else {
                          callback([]);
                        }
                      }}
                      value={selectedCustomer}
                      onChange={(e) => {
                        setSelectedCustomer(e);
                        // console.log("sdsdsgdsgds", e?.is_cash_only);
                        setFormInputs((prevState) => {
                          let newState = {
                            ...prevState,
                            cust_id: e.cust_id,
                            payment_mode_id:
                              e?.is_cash_only == 1
                                ? 1
                                : formInputs?.payment_mode_id,
                          };
                          return newState;
                        });
                        // focus.current[0].inv_no.focus();
                        focus.current[0].default_godown.focus();
                      }}
                      components={{
                        IndicatorsContainer: () => null,
                      }}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          minHeight: "0px",
                          height: "29px",
                        }),
                        valueContainer: (baseStyles, state) => ({
                          ...baseStyles,
                          paddingTop: "0px",
                          paddingBottom: "0px",
                          minHeight: "0px",
                          height: "29px",
                        }),
                        input: (baseStyles, state) => ({
                          ...baseStyles,
                          paddingTop: "0px",
                          paddingBottom: "0px",
                          marginTop: "0px",
                          marginBottom: "0px",
                          minHeight: "0px",
                          height: "29px",
                          fontSize: "12px",
                        }),
                        dropdownIndicator: (baseStyles, state) => ({
                          ...baseStyles,
                          paddingTop: "0px",
                          paddingBottom: "0px",
                        }),
                        option: (baseStyles, state) => ({
                          ...baseStyles,
                          paddingTop: "0px",
                          paddingBottom: "0px",
                        }),
                      }}
                      classNamePrefix="react-select"
                      tabSelectsValue
                    />
                  </div>
                  {multiVoucher == 1 ? (
                    <div className="col-md-3">
                      <label htmlFor="voucher_id">Challan Voucher Type</label>
                      <select
                        className="form-select"
                        value={formInputs.voucher_id}
                        name="voucher_id"
                        onChange={(e) => {
                          handleInputs(e);
                        }}
                      >
                        <option value="" hidden>
                          Select...
                        </option>
                        {voucherList &&
                          voucherList?.map((list) => (
                            <option key={list.voucher_id} value={list.voucher_id}>
                              {`${list.voucher_name}${
                                list.voucher_series || list.current_value
                                  ? ` (${list.voucher_series || ""}${list.current_value ?? ""})`
                                  : ""
                              }${list.sales_ledger ? ` - ${list.sales_ledger}` : ""}`}
                            </option>
                          ))}
                      </select>
                    </div>
                  ) : null}
                  <div className="col-md-3">
                    <label htmlFor="default_godown">Default Godown</label>
                    <select
                      ref={(el) => (focus.current[0].default_godown = el)}
                      className="form-select"
                      value={defaultGodown}
                      onChange={(e) => {
                        setDefaultGodown(e.target.value);
                        // setFormInputs(prevState => {
                        //     let newState = {...prevState}
                        //     let itemDtl = [...newState.item_dtl]
                        //     itemDtl = itemDtl.map(item => {
                        //         return {...item, godown_id: e.target.value}
                        //     })
                        //     return {
                        //         ...newState, item_dtl: itemDtl,
                        //     }
                        // });
                      }}
                    >
                      <option value="" hidden>
                        Select...
                      </option>
                      {godown &&
                        godown.map((list) => (
                          <option value={list.godown_id}>
                            {list.godown_name}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="challan_date">
                      Challan Date <span className="text-danger">*</span>
                    </label>
                    <input
                      // min={moment().format("YYYY-MM-DD")}
                      min={userBackDate()}
                      max={moment().format("YYYY-MM-DD")}
                      ref={(el) => (focus.current[0].challan_date = el)}
                      type="date"
                      className="form-control"
                      name="challan_date"
                      value={formInputs.challan_date}
                      onChange={(e) => {
                        handleInputs(e);
                      }}
                      onKeyDown={(e) => {
                        if (e.key == "Tab") {
                          return;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="payment_mode_id">Payment Mode</label>
                    <select
                      ref={(el) => (focus.current[0].payment_mode_id = el)}
                      className="form-select"
                      name="payment_mode_id"
                      value={formInputs.payment_mode_id}
                      // onChange={(e) => {
                      //   handleInputs(e);
                      // }}
                      onChange={(e) => {
                        const newPaymentMode = e.target.value;
                        setFormInputs((prevState) => {
                          let newState = {
                            ...prevState,
                            payment_mode_id: newPaymentMode,
                          };

                          // Auto-set is_zero_value based on payment mode
                          if (newPaymentMode === "2") {
                            newState.is_zero_value = "0"; // Auto Yes for Credit
                          } else {
                            newState.is_zero_value = "0"; // Auto No for others
                          }

                          return newState;
                        });
                      }}
                      disabled={
                        selectedCustomer?.is_cash_only == 1 ||
                          JSON.parse(localStorage.getItem("inventory")).userData
                            ?.role_id == 7
                          ? true
                          : false
                      }
                    >
                      {config.paymentMode &&
                        config.paymentMode.map((list) => (
                          <option value={list.value}>{list.label}</option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="vehicle_no">Vehicle No</label>
                    <input
                      ref={(el) => (focus.current[0].vehicle_no = el)}
                      type="text"
                      className="form-control"
                      name="vehicle_no"
                      value={formInputs.vehicle_no}
                      maxLength={20}
                      onChange={handleInputs}
                      onKeyDown={inputAlphanumeric}
                    />
                  </div>
                  {formInputs.payment_mode_id == "2" && (
                    <div className="col-md-3">
                      <label htmlFor="is_zero_value">Zero Valued</label>
                      <select
                        name="is_zero_value"
                        value={formInputs.is_zero_value}
                        onChange={handleInputs}
                        className="form-select"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                    </div>
                  )}
                  <div className="col-md-3">
                    <label htmlFor="narration">
                      Narration{" "}
                      {Number(totalRef?.current?.value?.replace(/,/g, "")) ===
                        0 && <span className="text-danger">*</span>}
                    </label>

                    <input
                      ref={(el) => (focus.current[0].narration = el)}
                      type="text"
                      className="form-control"
                      name="narration"
                      value={formInputs.narration}
                      onChange={handleInputs}
                      onKeyDown={inputAlphanumeric}
                      maxLength={100}
                    />
                  </div>
                </div>
                <div className="row gx-3 gy-2">
                  <div className="col-12">
                    <table
                      className="table mt-3 rounded"
                      cellPadding="0"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>
                            <div className="d-flex align-items-center gap-2">
                              Item Name <span className="text-danger">*</span>
                              <div className="position-relative d-flex align-items-center">
                                <input
                                  ref={barcodeRef}
                                  type="text"
                                  className="form-control form-control-sm"
                                  style={{ width: "120px" }}
                                  placeholder="Scan Barcode"
                                  value={barcode}
                                  onChange={(e) => setBarcode(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      scanBarcode(e);
                                    }
                                  }}
                                />
                                {barcodeLoading && (
                                  <div
                                    className="position-absolute end-0 me-2"
                                    style={{ zIndex: 10 }}
                                  >
                                    <span
                                      className="spinner-border spinner-border-sm text-primary"
                                      role="status"
                                      aria-hidden="true"
                                      style={{
                                        width: "0.8rem",
                                        height: "0.8rem",
                                      }}
                                    ></span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </th>
                          <th>
                            Godown <span className="text-danger">*</span>
                          </th>
                          <th>UOM</th>
                          <th width="150px">
                            {displayQty == "physical"
                              ? "Physical Qty"
                              : displayQty == "saleable"
                                ? "Saleable"
                                : displayQty == "both"
                                  ? "Physical (Saleable)"
                                  : "Avl. Qty"}
                          </th>
                          <th>
                            Reqd. Qty <span className="text-danger">*</span>
                          </th>

                          <th>
                            Rate <span className="text-danger">*</span>
                          </th>
                          {/*<th>Disc</th>*/}

                          <th>Amount</th>
                          {/*<th>Disc. Amt</th>*/}
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formInputs.item_dtl &&
                          formInputs.item_dtl.map((v, i) => (
                            <tr
                              key={i}
                              data-id={i}
                              className={
                                highlightedRow === i ? "scan-highlight" : ""
                              }
                              onClick={() => setHighlightedRow(i)}
                            >
                              <td style={{ width: "370px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    // justifyContent: "center",
                                    alignItems: "center",
                                    gap: "1px",
                                  }}
                                >
                                  <CommonAsyncSelect
                                    ref={(el) =>
                                      (focus.current[0][`prod_id_${i}`] = el)
                                    }
                                    autoFocus={true}
                                    getOptionLabel={(o) => o.item_name}
                                    placeholder="Enter atleast 3 character"
                                    getOptionValue={(o) => o.item_id}
                                    noOptionsMessage={() => null}

                                    defaultOptions={itemList}
                                    isLoading={itemLoading}
                                    loadOptions={async (inputValue, callback) => {
                                      let currentList = itemList;
                                      if (inputValue) {
                                        const search = inputValue.toLowerCase().trim();
                                        currentList = itemList.filter((item) =>
                                          item.item_name?.toLowerCase().includes(search) ||
                                          item.barcode?.toLowerCase().includes(search) ||
                                          item.SKU?.toLowerCase().includes(search)
                                        );
                                      }
                                      const filteredList = currentList.filter((item) => {
                                        const usedCount =
                                          formInputs.item_dtl.filter(
                                            (row, idx) =>
                                              idx !== i &&
                                              row.item_id ===
                                                item.item_id &&
                                              row.godown_id,
                                          ).length;
                                        return (
                                          usedCount < godown.length
                                        );
                                      });
                                      callback(filteredList);
                                    }}
                                    // filterOption={(candidate, input) => {
                                    //   if (
                                    //     selectedProduct.find(
                                    //       (p) => p.item_id === candidate.value
                                    //     )
                                    //   )
                                    //     return false;
                                    //   else return true;
                                    // }}
                                    value={
                                      selectedProduct.find(
                                        (p) =>
                                          p.item_id ==
                                          formInputs.item_dtl[i].item_id,
                                      ) || null
                                    }
                                    onChange={async (e) => {
                                      if (e?.item_id) {
                                        await $.post(
                                          `${config.apiUrl}/item/listItem`,
                                          JSON.stringify({
                                            paginate: 0,
                                            is_active: 1,
                                            item_id: e.item_id,
                                          }),
                                          (res) => {
                                            const fullItem = res?.data?.list?.[0] || e;
                                            setSelectedProduct((prevState) => {
                                              let newState = [...prevState];
                                              newState[i] = fullItem;
                                              return newState;
                                            });
                                            handleTableInputs({
                                              target: {
                                                name: "item_id",
                                                value: fullItem,
                                              },
                                            }, i);
                                            if (
                                              itemLevelNarration === 1 &&
                                              focus.current[`narration${i}`]
                                            ) {
                                              setTimeout(
                                                () =>
                                                  focus.current[
                                                    `narration${i}`
                                                  ].focus(),
                                                0,
                                              );
                                            }
                                            getAvlQty(fullItem, fullItem, i);
                                            focus.current[0][
                                              `godown_id_${i}`
                                            ].focus();
                                          }
                                        );
                                      }
                                    }}
                                    // onBlur={(e) => getAvlQty(e, v, i)}
                                    components={{
                                      IndicatorsContainer: () => null,
                                    }}
                                    styles={{
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        minHeight: "0px",
                                      }),
                                      valueContainer: (baseStyles, state) => ({
                                        ...baseStyles,
                                        paddingTop: "0px",
                                        paddingBottom: "0px",
                                        width: "400px",
                                      }),
                                      input: (baseStyles, state) => ({
                                        ...baseStyles,
                                        paddingTop: "0px",
                                        paddingBottom: "0px",
                                        marginTop: "0px",
                                        marginBottom: "0px",
                                        gridTemplateColumns: "0 100%",
                                      }),
                                      dropdownIndicator: (
                                        baseStyles,
                                        state,
                                      ) => ({
                                        ...baseStyles,
                                        paddingTop: "0px",
                                        paddingBottom: "0px",
                                      }),
                                      option: (baseStyles, state) => ({
                                        ...baseStyles,
                                        paddingTop: "0px",
                                        paddingBottom: "0px",
                                      }),
                                    }}
                                    classNamePrefix="react-select"
                                    tabSelectsValue
                                  />
                                  {formInputs.item_dtl[i]?.item_id ? (
                                    <Tippy content="View Item">
                                      <div>
                                        {" "}
                                        <span
                                          className=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() => handleItemView(v)}
                                        >
                                          <BiInfoCircle size={20} />
                                        </span>
                                      </div>
                                    </Tippy>
                                  ) : null}
                                </div>
                                {itemLevelNarration == 1 ? (
                                  <textarea
                                    ref={(el) => {
                                      if (el)
                                        focus.current[`narration${i}`] = el;
                                    }}
                                    placeholder="Item Narration"
                                    className="form-control mt-1"
                                    name={"narration"}
                                    value={v?.narration}
                                    maxLength={100}
                                    disabled={!formInputs.item_dtl[i]?.item_id}
                                    onChange={handleTableInputs}
                                    rows={2}
                                  />
                                ) : null}
                              </td>
                              <td width="170px">
                                <select
                                  ref={(el) =>
                                    (focus.current[0][`godown_id_${i}`] = el)
                                  }
                                  className="form-select"
                                  disabled={!formInputs.item_dtl[i]?.item_id}
                                  name="godown_id"
                                  value={v.godown_id}
                                  onChange={(e) => {
                                    handleTableInputs(e);
                                    getAvailableItem(
                                      v.item_id,
                                      e.target.value || v?.godown_id
                                        ? e.target.value || v?.godown_id
                                        : defaultGodown,
                                      i,
                                    );
                                  }}
                                >
                                  <option value="" hidden>
                                    Select...
                                  </option>
                                  {/* {godown &&
                                    godown.map((list) => (
                                      <option value={list.godown_id}>
                                        {list.godown_name}
                                      </option>
                                    ))} */}
                                  {godown
                                    .filter((g) => {
                                      const usedGodowns = formInputs.item_dtl
                                        .filter(
                                          (item, idx) =>
                                            idx != i &&
                                            item.item_id == v.item_id &&
                                            item.godown_id,
                                        )
                                        .map((item) => Number(item.godown_id));

                                      return !usedGodowns.includes(g.godown_id);
                                    })
                                    .map((list) => (
                                      <option
                                        key={list.godown_id}
                                        value={list.godown_id}
                                      >
                                        {list.godown_name}
                                      </option>
                                    ))}
                                </select>
                              </td>
                              <td style={{ width: "100px" }}>
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <select
                                    id=""
                                    name="uom"
                                    value={v?.uom}
                                    onChange={handleTableInputs}
                                    className="form-select"
                                  >
                                    {[v.base_uom, v.alt_uom].map((ele, ind) => (
                                      <option value={ele}>{ele}</option>
                                    ))}
                                  </select>
                                )}
                              </td>
                              <td align="center">
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  disabled
                                  name="requested_qty"
                                  value={
                                    displayQty === "physical"
                                      ? v.avail_qty // physical
                                      : displayQty === "saleable"
                                        ? v.billedQty // saleable
                                        : displayQty === "both"
                                          ? `${v.avail_qty} (${v.billedQty})`
                                          : v.avail_qty
                                  }
                                />
                              </td>
                              <td style={{ width: "100px" }}>
                                <input
                                  ref={(el) =>
                                  (focus.current[0][`requested_qty_${i}`] =
                                    el)
                                  }
                                  type="text"
                                  className="form-control text-end"
                                  name="requested_qty"
                                  value={v.requested_qty}
                                  disabled={!formInputs.item_dtl[i]?.item_id}
                                  maxLength={6}
                                  onChange={handleTableInputs}
                                  onKeyDown={(e) => {
                                    if (e.key == "Enter") {
                                      e.preventDefault();
                                      handleItemCount("+", i);
                                    } else {
                                      inputfourDigitDeciaml(e);
                                    }
                                  }}
                                  required
                                  onFocus={(e) =>
                                    setTimeout(() => {
                                      e.target.select();
                                    }, 50)
                                  }
                                />
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span
                                    className="text-right"
                                    style={{
                                      wordBreak: "break-all",
                                      fontSize: "10px",
                                    }}
                                  >
                                    <TruncatedTextWithTooltip
                                      text={uomConversionUnit(v)}
                                    />
                                  </span>
                                )}
                              </td>
                              <td style={{ width: "130px", maxWidth: "130px" }}>
                                <CustomCurrencyInput
                                  maxDecimal={4}
                                  currencyFormat="US"
                                  // style={{ width: "80px" }}
                                  value={
                                    v?.uom == v?.alt_uom
                                      ? v?.alt_price
                                      : v?.rate
                                  }
                                  name={
                                    v?.uom == v?.alt_uom ? "alt_price" : "rate"
                                  }
                                  maxDigit={12}
                                  className="form-control text-end"
                                  disabled={!formInputs.item_dtl[i]?.item_id}
                                  onKeyDown={(e) => {
                                    if (e.key == "Enter") {
                                      e.preventDefault();
                                      handleItemCount("+", i);
                                    } else {
                                      inputOnlyNumber(e);
                                    }
                                    {
                                      v?.alt_uom != null &&
                                        v?.alt_uom != "" && (
                                          <span
                                            className="text-right"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            {uomConversionUnit(v)}
                                          </span>
                                        );
                                    }
                                  }}
                                  onBlur={(e) => validatePriceRangeOnBlur(e, v)}
                                  onFocus={(e) =>
                                    setTimeout(() => {
                                      e.target.select();
                                    }, 50)
                                  }
                                  onChange={(val) => {
                                    handleTableInputs({
                                      target: {
                                        name:
                                          v?.uom == v?.alt_uom
                                            ? "alt_price"
                                            : "rate",
                                        value: val,
                                      },
                                    });
                                  }}
                                />
                                {/* <input
                                  // ref={el => focus.current[0][`base_price_${i}`] = el}
                                  type="text"
                                  className="form-control text-end"
                                  name={
                                    v?.uom == v?.alt_uom ? "alt_price" : "rate"
                                  }
                                  value={
                                    v?.uom == v?.alt_uom
                                      ? v?.alt_price
                                      : v?.rate
                                  }
                                  maxLength={12}
                                  // value={millionCommaRate(v?.rate) || v.rate}
                                  disabled={!formInputs.item_dtl[i]?.item_id}
                                  // onKeyUp={(e) => validatePriceRange(e, v)}
                                  onChange={handleTableInputs}
                                  onKeyDown={(e) => {
                                    if (e.key == "Enter") {
                                      e.preventDefault();
                                      handleItemCount("+", i);
                                    } else {
                                      inputOnlyNumber(e);
                                    }
                                    {
                                      v?.alt_uom != null &&
                                        v?.alt_uom != "" && (
                                          <span
                                            className="text-right"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            {uomConversionUnit(v)}
                                          </span>
                                        );
                                    }
                                  }}
                                  required
                                  // onBlur={validatePriceRange}
                                  onBlur={(e) => validatePriceRangeOnBlur(e, v)}
                                  onFocus={(e) =>
                                    setTimeout(() => {
                                      e.target.select();
                                    }, 50)
                                  }
                                /> */}
                                {/* {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span style={{ whiteSpace: "nowrap" }}>
                                    {`Per (`}
                                    <TruncatedTextWithTooltip text={v?.base_uom} />
                                    {`)`}
                                  </span>
                                )} */}
                                {v?.alt_uom != null &&
                                  v?.alt_uom !== "" &&
                                  (v?.uom == v?.alt_uom ? (
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {`( ${v?.rate} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ) : (
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {`(${v?.alt_price} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ))}
                              </td>
                              {/*<td>
                                                        <input
                                                            // ref={el => focus.current[0][`base_price_${i}`] = el}
                                                            type="text"
                                                            className="form-control text-end"
                                                            name="disc"
                                                            value={v.disc}
                                                            onChange={handleTableInputs}
                                                            onKeyDown={(e) => {
                                                                if (e.key == "Enter") {
                                                                    e.preventDefault();
                                                                    handleItemCount("+", i);
                                                                } else {
                                                                    inputOnlyNumber(e);
                                                                }
                                                            }}
                                                        />
                                                    </td>*/}

                              <td>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  name="amount"
                                  value={millionComma(v?.amount)}
                                  disabled
                                />
                              </td>
                              {/*<td>
                                                        <input
                                                            type="text"
                                                            className="form-control text-end"
                                                            name="disc_amt"
                                                            value={v.disc_amt}
                                                            disabled
                                                        />
                                                    </td>*/}
                              <td
                                style={{
                                  width: "80px",
                                  verticalAlign: "middle",
                                }}
                              >
                                <img
                                  src={addIcon}
                                  style={{ width: "17px", height: "17px" }}
                                  className="img-fluid m-1"
                                  alt=""
                                  onClick={() => handleItemCount("+", i)}
                                  role="button"
                                />
                                <img
                                  style={{ width: "17px", height: "17px" }}
                                  src={deleteIcon}
                                  className="img-fluid m-1"
                                  alt=""
                                  onClick={() => handleItemCount("-", i)}
                                  role="button"
                                />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="col-12 mt-2">
                    {(error || success) && (
                      <div
                        className={`alert alert-${error ? "danger" : "success"
                          } py-2 small`}
                        role="alert"
                      >
                        {error || success || ""}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 position-absolute bottom-0 start-0 end-0">
                  <div
                    className="row rounded px-2 py-3"
                    style={{ background: "#F4F7FE" }}
                  >
                    <div className="col-md-3">
                      <label htmlFor="totalRef">Gross Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="totalRef"
                        ref={totalRef}
                        disabled
                      />
                    </div>
                    <div className="col d-none">
                      <label htmlFor="discRef">Discount Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="discRef"
                        ref={discRef}
                        disabled
                      />
                    </div>
                    <div className="col d-none">
                      <label htmlFor="finalRef">Final Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="finalRef"
                        value={parseFloat(
                          Number(totalRef.current.value) -
                          Number(discRef.current.value),
                        ).toFixed(4)}
                        disabled
                      />
                    </div>
                    <div className="col d-flex mt-auto justify-content-end">
                      <div
                        style={{
                          border: "1px solid gray",
                          height: "32px",
                          minWidth: "200px",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <b className="me-2"> {getPaymentMode()} </b> :{" "}
                        {totalValue}
                      </div>

                      <button
                        onClick={handlePayDtl}
                        className="text-primary mt-1 me-4 border border-0 bg-transparent"
                      >
                        <BiCreditCard size={32} role="button" />
                      </button>
                      <button
                        className="ms-4 btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        onClick={handleSubmit}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <ApiSuccessModal
        showSccess={showSccess}
        handleSccessClose={handleSccessClose}
        handleSccessShow={handleSccessShow}
        resData={resData}
        createNewButtonText="Challan"
        navigateToList="/challan"
        navigateCreateNew={`/challan/add`}
        headerMsg={resData?.status == 200 ? "Success" : "Error"}
        challanId={resData?.data?.challan_no || "N/A"}
        qrImg={resData?.data?.png}
        printId={resData?.data?.challan_id}
      />
      {showPayDtl && (
        <PayDtlCard
          cardMode="add"
          showPayDtl={showPayDtl}
          handlePayDtl={handlePayDtl}
          formInputs={formInputs}
          setFormInputs={setFormInputs}
          grossTotal={removeMillionComma(totalRef.current.value)}
        />
      )}
      <Modal
        show={showItemModal}
        onHide={handleItemModalClose}
        keyboard={false}
        backdrop="static"
        size="lg"
      >
        <ItemViews id={selectedItemId} hide={handleItemModalClose} />
      </Modal>
    </>
  );
}

export default SaleAdd;
